import React, { useContext, useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { StoreContext } from '../../../../business/Provider';
import { Button } from 'primereact/button';
import { RadioButton } from 'primereact/radiobutton';
import { ProgressSpinner } from 'primereact/progressspinner';
import { CustomAlertDialog } from '../../../../components/Dialogs/CustomAlertDialog';
import { CollaboratorScreenNames } from '../../../../namesConstants/names';

export const WorkLocationRestrictionDialog = ({
	openWorkLocationRestrictionDialog,
	onClose,
	isMassive,
	selectedCollaborators,
	collaborator,
	updateCollaboratorOpenWorkArea
}) => {
	const [selectedOption, setSelectedOption] = useState(true);

	const close = () => {
		onClose();
	};

	useEffect(() => {
		if (openWorkLocationRestrictionDialog) {
			if (!isMassive && collaborator !== undefined && collaborator !== null){
				setSelectedOption(!collaborator.openWorkArea);
			} else if (isMassive) {
      			setSelectedOption(true);
    		}
		}
	}, [openWorkLocationRestrictionDialog]);

	const buttons = () => {
		return (
			<div
				className={`w-full flex flex-row space-x-2 justify-end items-end ${
					isMassive ? 'h-full pb-[10px]' : 'h-auto'
				}`}>
				<Button
					label='Cancelar'
					className='flex !h-4 !w-auto !bg-white text-white rounded-lg !boder !border-[#757575] !text-[#757575] '
					onClick={() => {
						close();
					}}
				/>
				<Button
					label='Guardar'
					className='flex !w-auto  !h-4 !bg-secondary-ShadowPCS002 text-white rounded-lg'
					onClick={() => {
						validateForm();
					}}
				/>
			</div>
		);
	};

	const content = () => {
		return (
			<div className='flex flex-col w-full h-full space-y-2'>
				{isMassive ? renderMassiveDialog()  : renderAlert()}
				{buttons()}
			</div>
		);
	};

	const renderAlert = () => {
    if (isMassive) return null; // en masivo usamos otro diálogo

    const customTitle = CollaboratorScreenNames.CustomAlertOpenWorkArea
      .replace('{fullname}', collaborator.fullName)
      .replace('{openWorkArea}', !collaborator.openWorkArea ? 'quitar' : 'habilitar');

    return (
      <CustomAlertDialog
        title={customTitle}
        setOpen={onClose}
        open={openWorkLocationRestrictionDialog}
        cancelLabel='No'
        agreeLabel='Si'
        agreeIcon='pi pi-check'
        onConfirmFunction={() => {
			
          updateCollaboratorOpenWorkArea(collaborator.id, !collaborator.openWorkArea);
        }}
        onCancelFunction={() => onClose()}
        style={{ width: '30vw' }}
      />
    );
  };

  const renderMassiveDialog = () => {
    if (!isMassive) return null;

    return (
      <Dialog
        header={<p className='text-[#5e5e5e] font-bold'>Ubicación</p>}
        visible={openWorkLocationRestrictionDialog}
        modal
        style={{ width: '35vw' }}
        onHide={() => onClose()}
      >
        <p className='mb-4 font-semibold text-gray-700'>
          Permitir registro de asistencia en:
        </p>

        <div className='flex flex-col gap-3'>
          <div className='flex items-center'>
            <RadioButton
              inputId='anywhere'
              name='location'
              value={true}
              onChange={(e) => setSelectedOption(e.value)}
              checked={selectedOption === true}
            />
            <label htmlFor='anywhere' className='ml-2'>
              Cualquier ubicación
            </label>
          </div>

          <div className='flex items-center'>
            <RadioButton
              inputId='workcenters'
              name='location'
              value={false}
              onChange={(e) => setSelectedOption(e.value)}
              checked={selectedOption === false}
            />
            <label htmlFor='workcenters' className='ml-2'>
              Dentro de sus centros y lugares de trabajo
            </label>
          </div>
        </div>

        <div className='flex justify-end gap-2 mt-6'>
          <Button label='Cancelar' className='p-button-text' onClick={() => onClose()} />
          <Button
            label='Guardar'
            onClick={() => {
				const collaboratorIds = selectedCollaborators
  					.map(c => c.id)
  					.join(',');
              updateCollaboratorOpenWorkArea(collaboratorIds, selectedOption);
              onClose();
            }}
          />
        </div>
      </Dialog>
    );
  };

	const { loadingState } = useContext(StoreContext);
	
	const renderLoading = () => {
		return loadingState ? (
			<div className='flex h-full w-full absolute top-0 left-0 right-0 z-50  bg-white opacity-80 justify-center content-center items-center flex-col'>
				<ProgressSpinner mode='indeterminate' className='flex w-full h-8 ' />
			</div>
		) : null;
	};

	return (
		<>
			{isMassive ? (
				renderMassiveDialog()
			) : (
				renderAlert()
			)}
			{renderLoading()}
		</>
	);
};
	